var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1231_12438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 34,
    r: 24,
    fill: "#0094AA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 25.0992C42.2 24.8992 41.8 24.8992 41.5 25.0992L35.7 28.8992H32C31.4 28.8992 31 29.2992 31 29.8992V30.8992H29C28.4 30.8992 28 31.2992 28 31.8992V33.9992V36.0992C28 36.6992 28.4 37.0992 29 37.0992H31V38.0992C31 38.5992 31.3 38.8992 31.8 39.0992L31 42.7992C30.9 43.0992 31 43.3992 31.2 43.5992C31.4 43.7992 31.7 43.9992 32 43.9992H33.9C34.3 43.9992 34.7 43.7992 34.8 43.3992L36.5 39.5992L41.4 42.7992C41.6 42.9992 41.8 42.9992 42 42.9992C42.2 42.9992 42.3 42.9992 42.5 42.8992C42.8 42.6992 43 42.3992 43 41.9992V33.9992V25.9992C43 25.5992 42.8 25.2992 42.5 25.0992ZM33 30.8992H35V37.0992H33V36.3992V36.0992V31.8992V31.1992V30.8992ZM30 35.0992V33.9992V32.8992H31V35.0992H30ZM33.3 41.9992L33.8 39.0992H34.6L33.3 41.9992ZM41 40.1992L37 37.5992V30.4992L41 27.8992V33.9992V40.1992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 33H45C44.4 33 44 33.4 44 34C44 34.6 44.4 35 45 35H47C47.6 35 48 34.6 48 34C48 33.4 47.6 33 47 33Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31C45.3 31 45.5 30.9 45.7 30.7L46.7 29.7C47.1 29.3 47.1 28.7 46.7 28.3C46.3 27.9 45.7 27.9 45.3 28.3L44.3 29.3C43.9 29.7 43.9 30.3 44.3 30.7C44.5 30.9 44.7 31 45 31Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7 37.3C45.3 36.9 44.7 36.9 44.3 37.3C43.9 37.7 43.9 38.3 44.3 38.7L45.3 39.7C45.5 39.9 45.8 40 46 40C46.2 40 46.5 39.9 46.7 39.7C47.1 39.3 47.1 38.7 46.7 38.3L45.7 37.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1231_12438",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.580392 0 0 0 0 0.666667 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1231_12438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1231_12438",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.560efbfa644e9b94233c809d9f630719.svg";
export { ForwardRef as ReactComponent };